namespace Solovis.UI {

    export class HtmlEditor {

        public container: JQuery;

        constructor(options) {
            var self = this;

            this.container = $(options.container);

            var tinymceOptions = {
                theme: "silver",
                selector: "tiny-editor",
                plugins: [
                    "advlist", "autolink", "lists", "link", "image", "charmap", "preview", "anchor", "pagebreak",
                    "searchreplace", "wordcount", "visualblocks", "visualchars", "code", "fullscreen",
                    "insertdatetime", "nonbreaking", "table", "directionality",
                    "template"
                ],
                toolbar1: "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | preview",
                menubar: 'edit instert view format table tools',

                init_instance_callback: function (editor) {
                    $(".tox-statusbar__branding").hide();
                    $(".tox-promotion").hide();
                    $(".tox-edit-area").css("height", "150px");
                },

                setup: function (editor) {
                    editor.on('init', function() {
                      if (options.initialValue) {
                        editor.setContent(options.initialValue);
                      }
                    });
                }
            };

            (self.container as any).tinymce(tinymceOptions);   
        }

        //TODO: something is up with the typing here, we really should be calling tinymce.getContent and tinymce.setContent for the following
        public getHtml() {
            return this.container.html();
        }

        public setHtml(value) {
            return this.container.html(value);
        }

    }

}
